import React, { useState } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import * as R from 'ramda';
import { EditorState } from 'draft-js';

import FormSettings from './FormSettings';
import { updateOrgs } from './utils';
import { closeDialog } from '../../../store/dialogs/actions';
import { submitNewForm, resetNewForm, updateNewForm } from '../../../store/forms/actions';
import { FORM_ACTION } from './constants'
import { decorator } from '../../UI/RichContent';

function NewForm (props) {
    const { dialogName } = props;

    const [editor, setEditor] = useState(EditorState.createEmpty(decorator));
    const [invalidName, setInvalidName] = useState(false);

    const dialogState = props.dialogs[dialogName];

    const updateField = ({ target }) => {
        const value = target.type === 'checkbox' ? target.checked : target.value;

        update(target.name, value);
    }

    const updateDateField = ({ date, name }) => update(name, date);

    const updateDaysOfWeek = ({ days, name }) => update(name, days);

    const update = (name, value) => {
        return props.updateNewForm({ [name]: value });
    };

    const updateOrganizations = ({ target }) => {
        const currentIds = props.newForm.organizationIds ? props.newForm.organizationIds : [];
        const organizationIds = updateOrgs(target.value, target.checked, currentIds);
        return props.updateNewForm({ organizationIds });
    }

    const handleClose = () => {
        props.resetNewForm();
        setEditor(EditorState.createEmpty(decorator));
        props.closeDialog(dialogName);
        setInvalidName(false);
    };

    const handleSave = () => {
        props.submitNewForm(props.history)
            .then(handleClose)
            .catch(({ validationErrors }) => {
                const nameError = R.find(({ fieldName }) => fieldName === "name", validationErrors);
                if (nameError) setInvalidName(nameError.message);
            });
    }

    return (
        <FormSettings
            form={props.newForm}
            dialogState={dialogState}
            handleSave={handleSave}
            handleClose={handleClose}
            updateField={updateField}
            updateDateField={updateDateField}
            updateDaysOfWeek={updateDaysOfWeek}
            invalidName={invalidName}
            editorState={{ editor, setEditor }}
            organizations={props.organizations}
            updateOrganizations={updateOrganizations}
            action={FORM_ACTION.create}
            editable={true}
        />
    );
}

const mapStateToProps = (state) => ({
    newForm: state.forms.newForm,
    dialogs: state.dialogs,
    organizations: state.user.profile.organizations
});

const mapDispatchToProps = (dispatch) => ({
    updateNewForm: data => dispatch(updateNewForm(data)),
    closeDialog: (dialog) => dispatch(closeDialog(dialog)),
    resetNewForm: () => dispatch(resetNewForm()),
    submitNewForm: (history) => dispatch(submitNewForm(history))
});

export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
)(NewForm);
